import React from 'react';
import ProductOffer from 'model/ProductOffer';
import { OfferInfoContainer } from './OfferInfo.styled';
import { ValidityInfo } from '../ValidityInfo';
import { ProducerInfo } from '../ProducerInfo';

export interface OfferInfoProps {
  product: ProductOffer;
  className?: string;
  smallFormat?: boolean;
}

export function OfferInfo({
  product,
  className,
  smallFormat = false,
}: OfferInfoProps) {
  return (
    <OfferInfoContainer className={`offer-info ${className}`}>
      <ValidityInfo product={product} smallFormat={smallFormat} />
      <ProducerInfo product={product} />
    </OfferInfoContainer>
  );
}
